import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const ClientListRaw = React.lazy(() => import(/* webpackChunkName: "ClientList" */ './ClientList'));
export const ClientList = () => (React.createElement(Page, { title: "Client List", description: "Client List" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(ClientListRaw, null)))));
